import sweetAlert from "src/bmAlert"
import { EnhancementAddOn } from "../keywords/keyword-form/enhancement-addons.enum"

export class EnhancementAlertHelper {
  static openEnhancementsModal($event: Event, addOnCode: string, videoModalVisible: () => void): void {
    EnhancementAddOn.optimize
    $event.stopPropagation()
    switch (addOnCode) {
      case EnhancementAddOn.optimize:
        sweetAlert.confirm({
          title: `<div class="text-no-transform d-flex flex-column text-left"><span>+OPTIMIZE</span></div>`,
          text: `<p class='font-weight-light mb-0'>Save time and resources. For each piece of content, we will:</p>
                <ul>
                  <li class='font-weight-light'>Double check keyword usage</li>
                  <li class='font-weight-light'>Optimize for your meta description, URL, and headers</li>
                  <li class='font-weight-light'>Proofread 2x</li>
                  <li class='font-weight-light'>Choose stock photos</li>
                  <li class='font-weight-light'>Format and schedule inside your CMS or via Google doc</li>
                </ul>`,
          confirmButtonText: 'Close',
          showCancelButton: false
        }).then(confirm => {
          if (confirm) return
          window.open("https://help.verblio.com/en/articles/2709107-what-is-optimize", "_blank")
        })
        break

      case EnhancementAddOn.photo:
        sweetAlert.confirm({
          title: `<div class="text-no-transform d-flex flex-column text-left"><span>+PHOTO</span></div>`,
          text: `<p class='font-weight-light mb-0'>Add hand-selected stock photos to complement your content.</p>
                <ul>
                  <li class='font-weight-light'>High quality stock photography</li>
                  <li class='font-weight-light'>Royalty-free images (copyrights secured)</li>
                  <li class='font-weight-light'>Helpful tags and captions</li>
                </ul>`,
          confirmButtonText: 'Close',
          showCancelButton: false
        }).then(confirm => {
          if (confirm) return
          window.open("https://help.verblio.com/en/articles/6241921-what-is-verblio-photo", "_blank")
        })
        break

      case EnhancementAddOn.video:
        videoModalVisible()
        break
    }
  }
}
